import { PS, T } from '../../lib/theme';
import type { StatBreakdown } from '../../lib/types';

interface BreakdownListProps {
  data: StatBreakdown[];
  format?: (v: number) => string;
}

/** Labeled rows with a proportional inline bar and a formatted value. */
export function BreakdownList({ data, format }: BreakdownListProps) {
  if (data.length === 0) {
    return <div style={{ ...T.caption }}>No data for this period.</div>;
  }
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {data.map((d) => (
        <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ ...T.ui, width: 110, color: PS.nearBlack, textTransform: 'capitalize' }}>
            {d.label}
          </div>
          <div style={{ flex: 1, background: PS.borderLight, borderRadius: 3, height: 10 }}>
            <div
              style={{
                width: `${(d.value / max) * 100}%`,
                background: PS.tealDeep,
                height: 10,
                borderRadius: 3,
              }}
            />
          </div>
          <div style={{ ...T.bodyBold, width: 90, textAlign: 'right', color: PS.nearBlack }}>
            {format ? format(d.value) : d.value.toLocaleString('en-US')}
          </div>
        </div>
      ))}
    </div>
  );
}
